var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));

// src/apollo-client-wrapper.ts
import { useEffect, useMemo } from "react";
import { useQuery as apolloUseQuery } from "@apollo/client";
import { useComponentRumTracker } from "@shared-ui/core-real-user-monitoring/context";

// src/event/log-event.ts
import { datadogRum } from "@datadog/browser-rum-slim";
var logEvent = (event, componentName) => {
  var _a, _b;
  const timestamp = performance.now();
  (_b = (_a = datadogRum).addAction) == null ? void 0 : _b.call(_a, event, {
    componentName,
    startTime: timestamp
  });
};
var logError = (error, componentName) => {
  var _a, _b;
  const timestamp = performance.now();
  const {
    message
  } = error;
  const context = {
    event: "COMPONENT_FAILED" /* COMPONENT_FAILED */,
    type: error.name || "UnknownError",
    source: error.networkError ? "network" : "custom",
    componentName,
    startTime: timestamp
  };
  (_b = (_a = datadogRum).addError) == null ? void 0 : _b.call(_a, message, context);
};

// src/util/get-component-name.ts
var getComponentName = query => {
  var _a, _b, _c;
  let operationName;
  try {
    operationName = ((_c = (_b = (_a = query == null ? void 0 : query.definitions) == null ? void 0 : _a.find(def => (def == null ? void 0 : def.kind) === "OperationDefinition" && "name" in def)) == null ? void 0 : _b.name) == null ? void 0 : _c.value) || "UnknownOperation";
  } catch (e) {
    operationName = "UnknownOperation";
  }
  return operationName.replace(/query$/i, "");
};

// src/apollo-client-wrapper.ts
function useQuery(query, options = /* @__PURE__ */Object.create(null)) {
  var _a;
  const componentId = useMemo(() => Math.random().toString(36).slice(2), []);
  const shouldLogPerformance = Boolean((_a = options == null ? void 0 : options.context) == null ? void 0 : _a.shouldLogPerformance) && !(options == null ? void 0 : options.skip);
  const componentName = getComponentName(query);
  const {
    trackEvent
  } = useComponentRumTracker({
    componentId,
    componentName
  });
  useEffect(() => {
    try {
      if (shouldLogPerformance) {
        logEvent("COMPONENT_START" /* COMPONENT_START */, componentName);
        trackEvent("componentStart");
      }
    } catch (e) {}
  }, []);
  const result = apolloUseQuery(query, __spreadProps(__spreadValues({}, options), {
    onCompleted: data2 => {
      var _a2;
      (_a2 = options.onCompleted) == null ? void 0 : _a2.call(options, data2);
      try {
        if (shouldLogPerformance) {
          logEvent("COMPONENT_CONTENT_READY" /* COMPONENT_CONTENT_READY */, componentName);
          trackEvent("componentContentReady");
        }
      } catch (e) {}
    }
  }));
  const {
    loading,
    error,
    data
  } = result;
  useEffect(() => {
    try {
      if (shouldLogPerformance) {
        if (error) {
          logError(error, componentName);
          trackEvent("componentFailed", {
            error
          });
        }
        if (!loading && !error && data) {
          logEvent("COMPONENT_READY_FOR_INTERACTION" /* COMPONENT_READY_FOR_INTERACTION */, componentName);
          trackEvent("componentReadyForInteraction");
        }
      }
    } catch (e) {}
  }, [loading, error, data, componentName, trackEvent, shouldLogPerformance]);
  return result;
}

// src/index.ts
import { ApolloClient, ApolloLink, ApolloError, Observable, InMemoryCache, gql, useMutation, useLazyQuery, ApolloProvider, createHttpLink, useApolloClient, makeVar, useReactiveVar, NetworkStatus } from "@apollo/client";
import { MockedProvider, MockLink } from "@apollo/client/testing";
import { cloneDeep, getOperationName } from "@apollo/client/utilities";
export { ApolloClient, ApolloError, ApolloLink, ApolloProvider, InMemoryCache, MockLink, MockedProvider, NetworkStatus, Observable, cloneDeep, createHttpLink, getOperationName, gql, makeVar, useApolloClient, useLazyQuery, useMutation, useQuery, useReactiveVar };
//# sourceMappingURL=index.js.map